import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=1ca6d710&scoped=true"
import script from "./hot.vue?vue&type=script&lang=js"
export * from "./hot.vue?vue&type=script&lang=js"
import style1 from "./hot.vue?vue&type=style&index=1&id=1ca6d710&prod&lang=scss"
import style2 from "./hot.vue?vue&type=style&index=2&id=1ca6d710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6d710",
  null
  
)

export default component.exports